<template>
    <div>
        <div
            class='w-100 p-2 text-center rounded-top'
            :style="$bgColor(color.primary)"
        >
            <h3
                class='card-title mt-2 mb-0'
                :style="{ color: color.secondary }"
            >
                {{ $t('gamification.gamification_ranking') }}
            </h3>
        </div>
        <card class='container rounded-bottom'
            :style="{ backgroundColor: backgroundColor }"
        >
            <div class='gamification-points-body'>
                <template
                    v-if="rankingStudents.length > 0"
                >
                    <div
                        v-for="(student,i) in rankingStudents.slice(0, 7)"
                        :key="i"
                    >
                        <gamification-rank-line
                            class="mt-2"
                            :gamificationRules="gamificationRules"
                            :name="student.student_name"
                            :score="student.student_points"
                            :best-score="rankingStudents[0].student_points"
                            :user="student.user"
                            :color="color"
                        />
                    </div>
                </template>
                <template
                    v-else
                >
                    {{ $t('gamification.gamification_without_ranking') }}
                </template>
            </div>
        </card>
    </div>
</template>
    
<script>
import Card from '../../argon/components/Cards/Card';
import GamificationRankLine from './GamificationRankLine';
    
export default {
    name: 'GamificationRanking',

    components: {
        Card,
        GamificationRankLine,
    },

    props: {
        gamificationRules: Object,
        color: {
            type: Object,
            required: true,
        },
        student: {
            type: Object,
            required: true,
        },
        studentPlans: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            rankingStudents: [],
            backgroundColor: '#E7ECFB',
        };
    },

    methods: {
        async getRanking() {
            return window.axios
                .get(`/api/gamification/ranking`)
                .then(response => {
                    this.rankingStudents = response.data.data;
                })
                .catch(err => {
                    this.$notify({
                        type: 'danger',
                        message: err.response.data.error,
                    });
                    this.$emit('error', false)
                });
        }
    },

    async mounted() {
        await this.getRanking();
    }
};
</script>
    
<style scoped>
    .gamification-header {
        width: 100%;
        background-color: #EBEBEB;
        height: 100px;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .gamification-points-header {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .gamification-points-body {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .gamification-points-button {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .gamification-plan {
        padding: 10px 25px 10px 25px;
        text-align: center;
        height: 40px;
        border: 3px solid #5E72E4;
        border-radius: 50px;
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        margin-top: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 550px;
    }

    .gamification-plan::after {
        content: '...';
    }

    .gamification-plan:not(:empty)::after {
        content: '';
    }

    .nch-show-progress-button {
        padding: 5px 25px 5px 25px;
        height: 40px;
        border: none;
        border-radius: 50px;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
        background-color: #5E72E4;
        margin-top: 30px;
    }

    .nch-show-progress-button:focus {
        outline: none;
    }

    .card-title {
        font-size: 20px;
        font-weight: bold;
    }

    .rounded-top {
        border-top-left-radius: 25px !important;
        border-top-right-radius: 25px !important;
    }

    .rounded-bottom {
        border-bottom-left-radius: 25px !important;
        border-bottom-right-radius: 25px !important;
    }

    .nch-next-plan-button {
        background-color: transparent;
        border: none;
        position: absolute;
        right: 10px;
    }

    .nch-next-plan-button:focus {
        outline: none;
    }

    .mdi-xbox-controller {
        color: #F39B1F;
        font-size: 80px;
        margin-top: -100px;
        margin-right: 30px;
    }

    .mdi-map-marker-circle {
        color: #FFE543;
        font-size: 80px;
        margin-top: -100px;
    }

    .chat-balloon {
        background-color: #5E72E4;
        color: #fff;
        border-radius: 10px;
        padding: 10px;
        margin: 10px;
        display: inline-block;
        max-width: 100px;
        position: relative;
    }

    .chat-balloon.left {
        text-align: left;
    }

    .chat-balloon.right {
        text-align: right;
    }

    .chat-balloon.left::after,
    .chat-balloon.right::after {
        content: '';
        position: absolute;
        bottom: -10px;
        width: 0;
        height: 0;
        border-style: solid;
    }

    .chat-balloon.left::after {
        left: 15px;
        border-width: 10px 10px 0 10px;
        border-color: #5E72E4 transparent transparent transparent;
    }

    .chat-balloon.right::after {
        right: 15px;
        border-width: 10px 10px 0 10px;
        border-color: #5E72E4 transparent transparent transparent;
    }
</style>
    